module.exports = "App.Collections.DashboardCards = Backbone.Collection.extend({\n    model: App.Models.DashboardCard\n});\n"